<template>
  <div class>
    <el-tabs v-model="tabName">
      <el-tab-pane label="异常订单" name="first">
        <STable
          v-if="tabName==='first'"
          ref="tableref"
          :url="url"
          :columns="columns"
          :handles="handles"
          :query="query"
          :selection="false"
          label-width="90px"
        />
      </el-tab-pane>
      <el-tab-pane label="待支付订单" name="second">
        <STable
          v-if="tabName==='second'"
          ref="tableref1"
          :url="url1"
          :columns="columns1"
          :handles="handles1"
          :query="query1"
          :selection="false"
          label-width="120px"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import fieldFilter from '@/utils/fieldFilter.js'
export default {
  name: 'Daichulidingdan',
  components: {},
  data() {
    return {
      url: '/finance/order/getPendingOrderPage',
      url1: '/finance/order/getHistoryOrderPage?view=USER&orderStatus=0',
      tabName: 'first',
      columns: [
        {
          label: '充电单号',
          prop: 'startChargeSeq'
        },
        {
          label: '用户账号',
          prop: 'loginName'
        },
        {
          label: '归属企业',
          prop: 'belongOrg'
        },
        {
          label: '充电车辆',
          prop: 'plateNumber'
        },
        {
          label: '充电方式',
          prop: 'chargeTypeValue'
        },
        {
          label: '开始充电时间',
          prop: 'startTime',
          width: '150px'
        },
        {
          label: '结束充电时间',
          prop: 'endTime',
          width: '150px',
          template: (index, reocrd) => {
					  return reocrd.endTime ? reocrd.endTime : '--'
          }
        },
        {
          label: '异常原因',
          prop: 'reason',
          template: (index, record) => {
            if (record.reason === '1') {
              return '无结算数据'
            } else if (record.reason === '2') {
              return '充电时长异常'
            } else if (record.reason === '3') {
              return '充电金额异常'
            } else if (record.reason === '4') {
              return '充电电量异常'
            } else if (record.reason === '5') {
              return '设备离线'
            } else if (record.reason === '6') {
              return '手动转异常'
            } else {
              return '--'
            }
          }
        },
        {
          label: '充电时长',
          prop: 'chargeTime'
          // template: (index, reocrd) => {
          //   return this.getStartChargeSeqStat(reocrd.startChargeSeqStat);
          // }
        },
        {
          label: '已充电量（度）',
          prop: 'totalPower',
          template: (index, reocrd) => {
            return this.getFloat(reocrd.totalPower)
          }
        },
        {
          label: '电站名称',
          prop: 'stationName'
        },
        {
          label: '终端名称',
          prop: 'connectorName'
        },
        {
          label: '运营商',
          prop: 'orgName'
        },
        {
          label: '订单类型',
          prop: 'orderType',
          template: (index, record) => {
            return record.orderType == 0 ? '平台' : '流量方'
          }
        },
        {
		  label: '异常原因',
		  prop: 'payTypeDesc',
		  template: function(index, record) {
            if (record.reason === '1') {
			  return '无结算数据'
            } else if (record.reason === '2') {
			  return '充电时长异常'
            } else if (record.reason === '3') {
			  return '充电金额异常'
            } else if (record.reason === '4') {
			  return '充电电量异常'
            } else if (record.reason === '5') {
			  return '设备离线'
            } else if (record.reason === '6') {
			  return '手动转异常'
            }
		  }
        }
      ],
      columns1: [
        {
          label: '充电单号',
          prop: 'startChargeSeq'
        },
        {
          label: '用户账号',
          prop: 'loginName'
        },
        {
          label: '归属企业',
          prop: 'belongOrg'
        },
        {
          label: '充电车辆',
          prop: 'plateNumber'
        },
        {
          label: '充电方式',
          prop: 'chargeTypeValue'
        },
        {
          label: '订单金额',
          prop: 'totalMoney',
          template: (index, reocrd) => {
            return this.getFloat(reocrd.totalMoney)
          }
        },
        {
          label: '开始充电时间',
          prop: 'startTime',
          width: '150px'
        },
        {
          label: '结束充电时间',
          prop: 'endTime',
          width: '150px',
          template: (index, reocrd) => {
            return reocrd.endTime ? reocrd.endTime : '--'
          }
        },
        {
          label: '充电时长',
          prop: 'chargeTime'
          // template: (index, reocrd) => {
          //   return this.getStartChargeSeqStat(reocrd.startChargeSeqStat);
          // }
        },
        {
          label: '已充电量（度）',
          prop: 'totalPower',
          template: (index, reocrd) => {
            return this.getFloat(reocrd.totalPower)
          }
        },
        {
          label: '起始SOC',
          prop: 'startSOC',
          template: (index, reocrd) => {
            return reocrd.startSOC ? parseFloat(reocrd.startSOC) + '%' : '--'
          }
        },
        {
          label: '结束SOC',
          prop: 'endSOC',
          template: (index, reocrd) => {
            return reocrd.endSOC ? parseFloat(reocrd.endSOC) + '%' : '--'
          }
        },
        {
          label: '电站名称',
          prop: 'stationName'
        },
        {
          label: '终端名称',
          prop: 'connectorName'
        },
        {
          label: '运营商',
          prop: 'orgName'
        },
        {
          label: '订单类型',
          prop: 'orderType',
          template: (index, record) => {
            return record.orderType == 0 ? '平台' : '流量方'
          }
        }
      ],
      // 操作栏
      handles: {
        width: 120,
        btns: [
          {
            label: '处理',
            icon: 'el-icon-edit',
            permission: 'order.pending.handle',
            handle: resp => {
              this.$router.push({ path: './processingPending', query: { data: resp.id }})
            }
          }
		  // ,
          //       {
          //         label: '详情',
          //         icon: 'el-icon-view',
          //         permission: 'order.pending.details',
          //         handle: resp => {
          //           this.$router.push({ path: './pendingDetail', query: { data: resp.id }})
          //         }
          //       }
        ]
      },
      // 操作栏
      handles1: {
        width: 200,
        btns: [
          {
            label: '详情',
            icon: 'el-icon-view',
            permission: 'order.pending.details',
            handle: resp => {
              this.$router.push({ path: './historyDetaill', query: { data: resp.id, num: resp.startChargeSeq, isdzf: true }})
            }
          },
          {
            label: '手动结算',
            permission: 'order.pending.settlement',
            isConfirm: true,
            confirmText: '确定要手动结算当前待支付订单吗？（手动结算不使用优惠券）？',
            url: '/finance/order/pay',
            method: 'post',
            before: (index, record) => {
              return {
                id: record.id
              }
            },
            handle: (resp) => {
              this.$notify({
                title: '成功',
                message: '手动结算成功',
                type: 'success'
              })
              this.$refs.tableref1.queryTable()
            }
          }
        ]
      },
      query: [
        {
          label: '开始时间',
          prop: 'startTime',
          placeholder: '',
          type: 'date2'
        },
        {
          label: '充电单号',
          prop: 'startChargeSeq',
          placeholder: '请输入充电单号'
        },
        {
          label: '用户账号',
          prop: 'loginName',
          placeholder: '请输入用户账号'
        },
        {
          label: '用户姓名',
          prop: 'nickName',
          placeholder: '请输入用户姓名'
        },
        {
          label: '归属企业',
          prop: 'orgName',
          placeholder: '请输入归属企业'
        },
        {
          label: '订单类型',
          prop: 'orderType',
          placeholder: '请选择订单类型',
          type: 'select',
          data: [
            {
              label: '平台',
              value: 0
            },
            {
              label: '流量方',
              value: 1
            }
            // {
            //   label: "车辆机构",
            //   value: 2
            // },
          ]
        },
        {
          label: '运营商',
          prop: 'operatorName',
          placeholder: '请输入运营商'
        },
        {
          label: '运营商属性',
          prop: 'attr',
          placeholder: '请选择运营商属性',
          type: 'select',
          data: [
            {
              label: '自营',
              value: 0
            },
            {
              label: '加盟',
              value: 1
            },
            {
              label: '互联互通',
              value: 2
            }
          ]
        },
        {
          label: '电站名称',
          prop: 'stationName',
          placeholder: '请输入电站名称'
        },
        {
          label: '终端名称',
          prop: 'connectorName',
          placeholder: '请输入终端名称'
        },
        {
          label: '充电车辆',
          prop: 'plateNumber',
          placeholder: '请输入充电车辆'
        },
        {
          label: '异常原因',
          prop: 'reason',
          placeholder: '请选择异常原因',
          type: 'select',
          data: [
            {
              label: '无结算数据',
              value: 1
            },
            {
              label: '充电时长异常',
              value: 2
            },
            {
              label: '充电金额异常',
              value: 3
            },
            {
              label: '充电电量异常',
              value: 4
            },
            {
              label: '设备离线',
              value: 5
            },
            {
              label: '手动转异常',
              value: 6
            }
          ]
        }
        // {
        //   label: "充电方式",
        //   prop: "chargeType",
        //   placeholder: "请输入充电方式"
        // },
        // {
        //   label: '充电卡号',
        //   prop: 'chargeCardNum',
        //   placeholder: '请输入充电卡号'
        // },
        // {
        //   label: "充电模式",
        //   prop: "chargeMode",
        //   placeholder: "请选择充电模式",
        //   type: "select",
        //   data: [
        //     {
        //       label: "单充",
        //       value: 0
        //     },
        //     {
        //       label: "双枪并充",
        //       value: 1
        //     },
        //   ]
        // },
        // {
        //   label: "结束时间",
        //   prop: "endTime",
        //   placeholder: "",
        //   type: "date2"
        // }
      ],
      query1: [
        {
          label: '开始充电',
          prop: 'startTime',
          placeholder: '',
          type: 'date2'
        },
        {
          label: '结束充电',
          prop: 'endTime',
          placeholder: '',
          type: 'date2'
        },
        {
          label: '充电单号',
          prop: 'startChargeSeq',
          placeholder: '请输入充电单号'
        },
        {
          label: '充电方式',
          prop: 'chargeType',
          placeholder: '请输入充电方式',
          type: 'select',
          data: [
            {
              label: '平台APP',
              value: 'APP'
            },
            {
              label: '平台小程序',
              value: 'WSP'
            },
            {
              label: '平台刷卡',
              value: 'CARD'
            },
            {
              label: '第三方',
              value: 'OTHER'
            },
            {
              label: 'VIN码充电',
              value: 'VIN'
            }
          ]
        },
        {
          label: '用户账号',
          prop: 'loginName',
          placeholder: '请输入用户账号'
        },
        {
          label: '用户姓名',
          prop: 'userName',
          placeholder: '请输入用户姓名'
        },
        {
          label: '归属企业',
          prop: 'belongOrg',
          placeholder: '请输入归属企业'
        },
        {
          label: '订单类型',
          prop: 'orderType',
          placeholder: '请选择订单类型',
          type: 'select',
          data: [
            {
              label: '平台',
              value: 0
            },
            {
              label: '流量方',
              value: 1
            }
          ]
        },
        {
          label: '电站名称',
          prop: 'stationName',
          placeholder: '请输入电站名称'
        },
        {
          label: '终端名称',
          prop: 'connectorName',
          placeholder: '请输入终端名称'
        },
        {
          label: '运营商',
          prop: 'orgName',
          placeholder: '请输入运营商'
        },
        {
          label: '运营商属性',
          prop: 'orgType',
          placeholder: '请选择运营商属性',
          type: 'select',
          data: [
            {
              label: '自营',
              value: 0
            },
            {
              label: '加盟',
              value: 1
            },
            {
              label: '互联互通',
              value: 2
            }
          ]
        },
        {
          label: '充电车辆',
          prop: 'plateNumber',
          placeholder: '请输入充电车辆'
        }
      ]
    }
  },
  computed: {},
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
        const tabs = localStorage.getItem('tabName')
    if(tabs === "second"){
      this.tabName = "second"
    } 
    localStorage.removeItem('tabName');
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {

  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
</style>



// WEBPACK FOOTER //
// src/views/orderManagement/pendingOrders.vue